/**
 * AppSync Events API config for Portal Maintenance.
 * Endpoint DNS from the console often omits `/event`; Amplify requires 
 */
function withEventPath(endpoint) {
  if (!endpoint) return null;

  const trimmed = String(endpoint).trim().replace(/\/+$/, "");
  if (!trimmed) return null;

  if (/\/event$/i.test(trimmed)) return trimmed;
  return `${trimmed}/event`;
}

function buildEventsConfig({ endpoint, apiKey, region = "us-east-1" }) {
  const resolvedEndpoint = withEventPath(endpoint);
  if (!resolvedEndpoint || !apiKey) return null;

  return {
    endpoint: resolvedEndpoint,
    region,
    defaultAuthMode: "apiKey",
    apiKey,
    channel: "portal-maintenance",
  };
}

function getDevEventsConfig() {
  return buildEventsConfig({
    endpoint:
      "https://mln2ivp3g5dznlnpkitsiqqz2u.appsync-api.us-east-1.amazonaws.com",
    apiKey: "da2-ovjyp4ddpnfljamvshf272duva",
  });
}

function getUatEventsConfig() {
  return buildEventsConfig({
    endpoint:
      "https://62b62vxtszhuxnppk57cdn45hy.appsync-api.us-east-1.amazonaws.com",
    apiKey: "da2-xo5vdm43dbaejhdqoxpvzjys34",
  });
}

function getProdEventsConfig() {
  return buildEventsConfig({
    endpoint:
      "https://vvp7lui2qzewdohsqg33t2res4.appsync-api.us-east-1.amazonaws.com",
    apiKey: "da2-lhlijfmpzvdqpm37rlosnihiiy",
  });
}

export default function getPortalMaintenanceEventsConfig() {
  switch (window.location.hostname) {
    case "www.uat.portal.rcshealth.io":
    case "uat.portal.rcshealth.io":
      return getUatEventsConfig();

    case "www.dev.portal.rcshealth.io":
    case "dev.portal.rcshealth.io":
    case "localhost":
      return getDevEventsConfig();

    case "www.portal.rcshealth.io":
    case "portal.rcshealth.io":
      return getProdEventsConfig();

    default:
      return null;
  }
}

export function getAmplifyEventsApiConfig() {
  const config = getPortalMaintenanceEventsConfig();
  if (!config) return null;

  return {
    endpoint: config.endpoint,
    region: config.region,
    defaultAuthMode: config.defaultAuthMode,
    apiKey: config.apiKey,
  };
}
